import React from 'react';
import { Modal, Button, Badge } from 'react-bootstrap';
import { UserType } from 'store/userSlice';

interface ViewUserModalProps {
  show: boolean;
  handleClose: () => void;
  user: UserType;
}

const ViewUserModal: React.FC<ViewUserModalProps> = ({
  show,
  handleClose,
  user
}) => {
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="bg-light">
        <Modal.Title className="fs-6">
          <i className="fas fa-eye me-2"></i>
          User Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          {/* Basic Information */}
          <div className="row mb-4">
            <div className="col-12">
              <h6 className="text-primary mb-3 border-bottom pb-2">
                Basic Information
              </h6>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-700 mb-1">Full Name</label>
              <div className="fs-6">{user.name || '-'}</div>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-700 mb-1">Email Address</label>
              <div className="fs-6">
                <a
                  href={`mailto:${user.email}`}
                  className="text-decoration-none"
                >
                  {user.email || '-'}
                </a>
              </div>
            </div>
          </div>

          {/* Role & Status */}
          <div className="row mb-4">
            <div className="col-12">
              <h6 className="text-primary mb-3 border-bottom pb-2">
                Role & Status
              </h6>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-700 mb-1">Role</label>
              <div>
                <Badge bg="primary" className="fs-9">
                  {user.role_name || `Role ${user.role_id}`}
                </Badge>
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-700 mb-1">Status</label>
              <div>
                <Badge
                  bg={user.is_active ? 'success' : 'secondary'}
                  className="fs-9"
                >
                  {user.is_active ? 'Active' : 'Inactive'}
                </Badge>
              </div>
            </div>
          </div>

          {/* Organization Information */}
          <div className="row mb-4">
            <div className="col-12">
              <h6 className="text-primary mb-3 border-bottom pb-2">
                Organization
              </h6>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-700 mb-1">Company</label>
              <div className="fs-6">
                {user.company_name ? (
                  <span>{user.company_name} </span>
                ) : (
                  user.company_id || '-'
                )}
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-700 mb-1">Department</label>
              <div className="fs-6">
                {user.department_name ? (
                  <span>{user.department_name} </span>
                ) : (
                  user.department_id || '-'
                )}
              </div>
            </div>
          </div>

          {/* Additional Information */}
          <div className="row">
            <div className="col-12">
              <h6 className="text-primary mb-3 border-bottom pb-2">
                Additional Information
              </h6>
            </div>

            <div className="col-12 mb-3">
              <label className="form-label text-700 mb-1">
                Account Created
              </label>
              <div className="fs-6">
                {user.created_at ? (
                  <span>{new Date(user.created_at).toLocaleDateString()}</span>
                ) : (
                  '-'
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-top-0">
        <Button
          variant="phoenix-secondary"
          onClick={handleClose}
          className="px-4"
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewUserModal;
